import { render, staticRenderFns } from "./DisponibilitaCard.vue?vue&type=template&id=da862074"
import script from "./DisponibilitaCard.vue?vue&type=script&lang=js"
export * from "./DisponibilitaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports